/**
 * Reading and writing the value format a multi-select persists.
 *
 * A stored multi-value is either a real array or a single string joining the entries
 * with commas, semicolons or newlines (both shapes exist in saved audit form data), so
 * parsing it is a precondition for handing react-select its selected options.
 */

const splitStoredMultiValue = (value) => {
  if (Array.isArray(value)) {
    return value
      .map((item) => String(item || '').trim())
      .filter(Boolean);
  }

  if (typeof value === 'string') {
    return value
      .split(/\r?\n|[,;]+/)
      .map((item) => item.trim())
      .filter(Boolean);
  }

  return [];
};

const getUniqueValues = (values = []) => Array.from(new Set(values.filter(Boolean)));

const mergeSelectedOptions = (selectedValues, options = []) => {
  const optionsMap = new Map(options.map((option) => [String(option.value), option]));
  options.forEach((option) => {
    if (option.code && !optionsMap.has(String(option.code))) optionsMap.set(String(option.code), option);
  });
  return getUniqueValues(splitStoredMultiValue(selectedValues)).map((value) => (
    optionsMap.get(String(value)) || {
      value,
      label: String(value),
    }
  ));
};

export { splitStoredMultiValue, getUniqueValues, mergeSelectedOptions };
